export default __webpack_public_path__ + "static/media/Boots of the Blood Drinker (nm).64515863.jpg";